export default class UpdateSnippet {
  constructor(context) {
    this.context = context;
  }

  run(id) {
    this.context.gateways.snippetCount.update(id);
  }
}
